import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import EssentialVocabularyEmbed from '../components/Exercise/EssentialVocabularyEmbed';

export default Node.create({
  name: 'essentialVocabularyExercise',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      vocabulary: { 
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('vocabulary');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing EssentialVocabulary from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.vocabulary) {
            return {
              vocabulary: JSON.stringify(attributes.vocabulary)
            };
          }
          return {};
        }
      },
      title: { 
        default: 'Essential Vocabulary',
        parseHTML: element => element.getAttribute('title') || 'Essential Vocabulary',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },
  parseHTML() {
    return [
      { tag: 'div[data-type="essential-vocabulary-exercise"]' },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'essential-vocabulary-exercise' })];
  },
  addNodeView() {
    return ReactNodeViewRenderer(EssentialVocabularyEmbed);
  },
  addCommands() {
    return {
      insertEssentialVocabularyExercise:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 